import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';

import { CommonService } from '@shared/services/common.service';
import { MetadataService, MetadataSlugs } from '@shared/services/metadata.service';
import {
  ReferenceCitationDisplayMode,
  ReferenceDisplayPreferencesService,
} from '@shared/services/reference-display-preferences.service';

@Component({
  selector: 'app-reference-citation-display',
  templateUrl: './reference-citation-display.component.html',
  styleUrls: ['./reference-citation-display.component.scss'],
  standalone: true,
  imports: [MatFormField, MatLabel, MatSelect, MatOption, FormsModule, MatButton],
})
export class ReferenceCitationDisplayComponent implements OnInit, OnDestroy {
  private readonly _metadataService = inject(MetadataService);
  private readonly _commonService = inject(CommonService);
  private readonly _referenceDisplayPrefs = inject(ReferenceDisplayPreferencesService);
  private _sub: Subscription | undefined;

  protected value: ReferenceCitationDisplayMode = 'all';

  ngOnInit(): void {
    this._metadataService.get<string>(MetadataSlugs.ReferenceCitationDisplayMode).subscribe({
      next: metadata => {
        const v = metadata?.value;
        if (v === 'source' || v === 'source_only') {
          this.value = 'source_only';
          return;
        }
        if (v === 'external' || v === 'ref_in_ref_only') {
          this.value = 'ref_in_ref_only';
          return;
        }
        this.value = 'all';
      },
      error: () => {
        this.value = 'all';
      },
    });
  }

  protected save(): void {
    this._sub = this._metadataService
      .set(MetadataSlugs.ReferenceCitationDisplayMode, this.value)
      .subscribe({
        next: () => {
          this._referenceDisplayPrefs.setPersistedMode(this.value);
          this._commonService.openSuccessSnackBar('Reference display preference saved.');
        },
        error: () => {
          this._commonService.openErrorSnackBar('Could not save reference display preference.');
        },
      });
  }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
  }
}
